import { useMemo } from "react";

import type { ReservationListFragment } from "@stepapp/core";
import { format } from "date-fns";

export const useSortOrders = (
  orders: ReservationListFragment[] | undefined,
  isCompletedScreen = false,
) => {
  const sortedOrders = useMemo(() => {
    if (orders?.length === 0) return [];

    const sortData =
      orders?.concat().sort((a, b) => {
        const aTime = new Date(a.startDate).getTime();
        const bTime = new Date(b.startDate).getTime();

        return isCompletedScreen ? bTime - aTime : aTime - bTime;
      }) || [];

    const groupedData = sortData.reduce(
      (acc, item) => {
        const key = format(item.startDate, "LLLL yyyy");
        if (acc[key]) {
          acc[key]?.push(item);
        } else {
          acc[key] = [item];
        }

        return acc;
      },
      {} as { [key: string]: ReservationListFragment[] },
    );

    return Object.keys(groupedData).map((key, i) => ({
      title: i === 0 ? "" : key,
      data: groupedData[key] || [],
    }));
  }, [orders, isCompletedScreen]);

  return sortedOrders;
};
